"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegPrefsModal = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const FormGroup_1 = __importDefault(require("@mui/material/FormGroup"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const mui_1 = require("tss-react/mui");
const core_1 = require("companion-app-components/utils/core");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const selectors_1 = require("data/datasetSharing/selectors");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const defaults_1 = require("data/preferences/defaults");
const utils_1 = require("utils/utils");
const data_1 = require("./data");
const style_1 = require("./style");
const utils_2 = require("./utils");
const useStyles = (0, mui_1.makeStyles)()(style_1.styles);
const isIe = require('is-iexplorer') || (0, utils_1.isOldEdge)(); // eslint-disable-line
const RegPrefsModal = ({ onClose }) => {
    const [showAdvanced, setShowAdvanced] = (0, react_1.useState)(false);
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const { classes } = useStyles();
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const hasWriteAccess = (0, react_redux_1.useSelector)((state) => (0, selectors_1.hasDatasetWriteAccess)(state));
    const prefAdvancedOption = featureFlags.get('prefAdvancedOption');
    const handleCheck = (field) => (event, checked) => {
        if (event && event.target) {
            setDatasetPreference({ transactionRegister: { [field]: checked } });
        }
        core_1.tracker.track(core_1.tracker.events.txnPrefs, {
            type: field,
            state: checked,
        });
    };
    const closeAndExit = () => {
        onClose();
    };
    const resetDefaults = () => {
        core_1.tracker.track(core_1.tracker.events.txnPrefs, {
            type: 'reset',
        });
        setDatasetPreference({ transactionRegister: defaults_1.defaultDatasetPreferences.transactionRegister });
    };
    const createPreferencesItems = (prefs, prefsData) => {
        const elements = prefsData.map((pref) => (<div style={{ display: 'flex' }} key={`RegPrefsItem-${pref.field}`}>
        <Typography_1.default className={classes.preferencesText} style={{ flexGrow: 2, marginTop: 'auto', marginBottom: 'auto' }}>
          {pref.label}
        </Typography_1.default>
        <Switch_1.default style={{ float: 'right' }} color="primary" checked={prefs[pref.field]} value={prefs[pref.field] ? 'on' : 'off'} onChange={handleCheck(pref.field)} id={pref.id}/>
      </div>));
        return elements;
    };
    const allPrefsData = (0, react_1.useMemo)(() => (0, utils_2.getAllPrefsData)(data_1.preferenceData, hasWriteAccess), [hasWriteAccess]); // eslint-disable-line react-hooks/exhaustive-deps
    const advancedPrefs = (0, react_1.useMemo)(() => (0, utils_2.getAdvancedPrefs)(allPrefsData, featureFlags), [featureFlags]);
    const prefsData = (0, react_1.useMemo)(() => (0, utils_2.getVisiblePrefsData)(allPrefsData, featureFlags), [featureFlags]);
    const noAdvanced = advancedPrefs.length === 0;
    return (<Dialog_1.default open classes={isIe ? { paper: classes.dialogPaper } : {}} onClose={onClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle_1.default>Transactions Preferences</DialogTitle_1.default>

      <DialogContent_1.default>
        <FormControl_1.default component="fieldset">
          {datasetPreferences && datasetPreferences.transactionRegister && (<FormGroup_1.default>
              {createPreferencesItems(datasetPreferences.transactionRegister, prefsData)}
              {prefAdvancedOption && !noAdvanced && <Divider_1.default />}
              {advancedPrefs.length > 0 && showAdvanced && (<>
                  <Typography_1.default variant="body1" style={{ marginTop: 10 }} className={classes.preferencesText}>
                    Advanced Options
                  </Typography_1.default>
                  {createPreferencesItems(datasetPreferences.transactionRegister, advancedPrefs)}
                </>)}
            </FormGroup_1.default>)}
        </FormControl_1.default>
        {prefAdvancedOption && !noAdvanced && (<ButtonBase_1.default className={classes.link} onClick={() => setShowAdvanced(!showAdvanced)} style={{ marginTop: 10, display: 'block', paddingLeft: 0 }} id={`pref:link-advanced:${showAdvanced ? 'on' : 'off'}`}>
            <Typography_1.default className={classes.link}>{showAdvanced ? '<<< Hide Advanced' : 'Advanced Options >>>'}</Typography_1.default>
          </ButtonBase_1.default>)}
      </DialogContent_1.default>

      <div className={classes.buttonArea}>
        <Button_1.default style={{ float: 'left' }} color="primary" onClick={resetDefaults} id="txn-pref-reset-to-defaults">
          Reset To Defaults
        </Button_1.default>
        <Button_1.default style={{ float: 'right' }} color="primary" onClick={closeAndExit} id="txn-pref-done">
          Done
        </Button_1.default>
      </div>
    </Dialog_1.default>);
};
exports.RegPrefsModal = RegPrefsModal;
exports.default = exports.RegPrefsModal;
